<template>

  <div v-if="hasUserAddresses" class="flex flex-col gap-1 relative my-4">
    <select
        id="shipping_address"
        :disabled="inProgress"
        class="select2-address w-full h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border rounded-[8px] outline-none transition-all focus-within:border-lime-green hover:border-lime-green border-light-gray/25 cursor-pointer"
        name="shipping_address"
    ></select>
    <span
        v-if="errors['shipping.address_id']"
        class="text-[12px] text-[#eb2635] text-left"
    >
      *{{ errors['shipping.address_id']?.[0] }}
    </span>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="flex flex-col gap-1 relative">
      <label :class="[shipping.city ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
             class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
             for="shipping_city">
        {{ in18['attribute_shipping_city'] }}
      </label>
      <input
          id="shipping_city"
          v-model="shipping.city"
          :class="[errors['shipping.city'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', shipping.city && 'pt-[30px]' ]"
          :disabled="inProgress"
          class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
          name="user_name"
          type="text"
          @input="clearValidationError('shipping.city')"
      >
      <span v-if="errors['shipping.city']?.length"
            class="!text-[12px] text-[#eb2635] text-left">*{{ errors['shipping.city']?.[0] }}</span>
    </div>
    <div class="flex flex-col gap-1 relative">
      <label :class="[shipping.address ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
             class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
             for="shipping_address">
        {{ in18['attribute_shipping_address'] }}
      </label>
      <input
          id="shipping_address"
          v-model="shipping.address"
          :class="[errors['shipping.address'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', shipping.address && 'pt-[30px]' ]"
          :disabled="inProgress"
          class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
          name="user_name"
          type="text"
          @input="clearValidationError('shipping.address')"
      >
      <span v-if="errors['shipping.address']?.length"
            class="!text-[12px] text-[#eb2635] text-left">*{{ errors['shipping.address']?.[0] }}</span>
    </div>
    <div class="flex flex-col gap-1 relative">
      <label :class="[shipping.zip ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
             class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
             for="shipping_zip">
        {{ in18['attribute_shipping_postcode'] }}
      </label>
      <input
          id="shipping_zip"
          v-model="shipping.zip"
          :class="[errors['shipping.zip'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', shipping.zip && 'pt-[30px]' ]"
          :disabled="inProgress"
          class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
          name="user_name"
          type="text"
          @input="clearValidationError('shipping.zip')"
      >
      <span v-if="errors['shipping.zip']?.length"
            class="!text-[12px] text-[#eb2635] text-left">*{{ errors['shipping.zip']?.[0] }}</span>
    </div>
    <div class="flex flex-col gap-1 relative overflow-hidden">
      <label :class="[shipping.user_phone_number.number ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
             class=" leading-[14px] font-light absolute left-[17px] transition-all pointer-events-none"
             for="mobile_phone_number">
        {{ in18['attribute_user_phone'] }}
      </label>

      <input
          id="user_email"
          v-model="shipping.user_phone_number.number"
          :class="[errors['shipping.user_phone_number.number'] || errors['shipping.user_phone_number.countryCallingCode'] ? 'border-[#eb2635] ' : 'focus-within:border-lime-green border-light-gray/25', shipping.user_phone_number.number ? 'pl-[100px] pt-[30px]' : 'pl-[16px]' ]"
          :disabled="inProgress"
          class="h-[52px] text-[16px] p-[16px]   font-light leading-[20px] text-charcoal border rounded-[8px] outline-none focus-within:border-lime-green transition-all"
          name="mobile_phone_number"
          type="number"
          @input="clearValidationError('shipping.user_phone_number.number')"
      >
      <div
          :class="[shipping.user_phone_number.number ? 'top-[23px] left-[16px] opacity-100': 'top-[-4px] left-[-60px] opacity-0 pointer-events-none']"
          class="absolute  text-[16px] font-thin leading-[20px] pr-2 border-r border-l-medium-gray transition-all">

        <span class="prefix">+</span>

        <select id="" v-model="shipping.user_phone_number.countryCallingCode"
                class="outline-none bg-opacity-0 w-[60px]"
                name="user_phone_country"
                v-bind:preventFocusShift="true" @update="clearValidationError('shipping.user_phone_number.countryCallingCode')">
          <option v-for="c in getEUPhoneCountries()" :value="c.countryCallingCode" class="text-[14px]">
            {{ c.countryCallingCode }}
          </option>
        </select>

      </div>

      <span v-if="phoneErrors?.length" class=" text-[12px] text-[#eb2635] text-left">*{{ phoneErrors?.[0] }}</span>
    </div>
  </div>


  <div class="flex flex-col gap-1 relative overflow-hidden mt-4">
    <label :class="[shipping.message ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
           class=" leading-[14px] font-light absolute left-[17px] transition-all pointer-events-none"
           for="shipping_message">
      {{ in18['attribute_shipping_message_option'] }}
    </label>
    <textarea
        id="shipping_message"
        v-model="shipping.message"
        :class="[errors['shipping.message'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', shipping.message ? 'pt-[30px]' : 'pt-[16px]' ]"
        :disabled="inProgress"
        class="min-h-[100px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border rounded-[8px] outline-none transition-all"
        name="shipping_message"
        @input="clearValidationError('shipping.message')"
    />
    <span v-if="errors['shipping.message']?.length"
          class=" text-[12px] text-[#eb2635] text-left">*{{ errors['shipping.message']?.[0] }}</span>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, watch} from 'vue';
import axios from 'axios';
import {getEUPhoneCountries} from '../../../helpers/phone-countries';

const props = defineProps({
  shippingMethod: {
    type:     Object,
    required: true,
  },
  shipping:       {
    type:     Object,
    required: true,
  },
  errors:         {
    type:     Object,
    required: true,
  },
  in18:           {
    type: Object,
  },
  inProgress:     {
    type: Boolean,
  },
  addresses:      {
    type: Array,
  }
});

const emit = defineEmits([
  'update-cart',
  'country-selected',
  'update-in-progress',
  'update-error',
  'update-shipping-address',
]);

const hasUserAddresses = ref(false);
const availableCountries = ref([]);
const selectedShippingAddress = ref(null);

// If availableRegions is derived from availableCountries
const availableRegions = computed(() => {
  // Modify this logic based on how regions are structured in your data
  return availableCountries.value.flatMap(country => country.regions || []);
});

watch(() => selectedShippingAddress.value, (address) => {
  // console.log('Selected Address ID:', address);
  emit('update-shipping-address', address);
});

const checkUserAddresses = () => {
  return axios.get('/api/shipping/user/addresses')
      .then(response => {
        const addresses = response.data.addresses || [];
        hasUserAddresses.value = addresses.length > 0;
      })
      .catch(error => {
        console.error('Failed to fetch user addresses:', error);
      }).finally(() => {
        if (hasUserAddresses.value) {
          initSelect2Addresses();
        }
      });
};

const filteredAreas = computed(() => {
  if (props.shipping.region_id === null) {
    return [];
  }
  const selectedRegion = availableRegions.value.find(
      region => region.id === props.shipping.region_id
  );
  return selectedRegion ? selectedRegion.areas : [];
});

const phoneErrors = computed(() => {
  let errors = [];
  if (props.errors['shipping.user_phone_number.number']) {
    errors = errors.concat(props.errors['shipping.user_phone_number.number']);
  }
  if (props.errors['shipping.user_phone_number.countryCallingCode']) {
    errors = errors.concat(
        props.errors['shipping.user_phone_number.countryCallingCode']
    );
  }
  return errors;
});

const validateZipCode = () => {
  // Notify the parent component about the progress update
  emit('update-in-progress', true);

  return axios
      .post(
          `/api/countries/${props.shipping.country_id}/validate-zip-code`,
          {shipping: props.shipping}
      )
      .then(response => {
        emit('update-cart', response.data.cart);
        ga_add_shipping_info_event(response.data.cart);
      })
      .catch(error => {
        window.toastr.error(error.response.data.message);
        emit(
            'update-error',
            'shipping.zip',
            error.response.data.errors['shipping.zip']
        );
      })
      .finally(() => {
        // Notify the parent component that the operation is complete
        emit('update-in-progress', false);
      });
};

const clearValidationError = (fieldName) => {
  if (props.errors[fieldName]) {
    // Since we cannot directly mutate props, emit an event to update the error
    emit('update-error', fieldName, null);
  }
};

const fetchCountries = () => {
  if (!props.shippingMethod) {
    return;
  }

  // Notify the parent component about the progress update
  emit('update-in-progress', true);

  return axios
      .get(`/api/shipping/${props.shippingMethod.id}/countries`)
      .then(response => {
        availableCountries.value = response.data.countries;
      })
      .catch(error => {
        window.toastr.error(error.response.data.message);
      })
      .finally(() => {
        // Notify the parent component that the operation is complete
        emit('update-in-progress', false);
      });
};

function initSelect2Addresses() {
  console.log('init');
  const $el = $('#shipping_address');

  $el.off(); // prevent multiple bindings

  $el.select2({
    placeholder: props.in18['select_address'],
    width:       '100%',
    allowClear:  false,
    ajax:        {
      delay:    500,
      url:      '/api/shipping/user/addresses', // replace with real API endpoint
      type:     'GET',
      dataType: 'json',
      data(params) {
        return {
          search: params.term,
        };
      },
      processResults(data) {
        return {
          results: data.addresses.map((address) => ({
            id:   address.id,
            text: `${address.full_address}`,
            ...address,
          })),
        };
      },
      cache: true,
    },
  }).on('select2:select', (e) => {
    const selected = e.params.data;

    props.shipping.city = selected.city;
    props.shipping.address = selected.address;
    props.shipping.zip = selected.zip;
    props.shipping.country_id = selected.country_id;

    emit('update-shipping-address', selected);
  });
}

onMounted(() => {
  fetchCountries();
  checkUserAddresses();
});
</script>

<style>

select#locker_country_id {
  padding-right: 2rem; /* Adjust to match text padding */
  -webkit-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23333' d='M5 6L0 0h10L5 6z'/%3E%3C/svg%3E"); /* Smaller arrow icon */
  background-position: right 16px center;
  background-repeat: no-repeat;
}

/* Same select2 style as locker */
.select2-selection.select2-selection--single {
  @apply w-full h-[52px] text-[16px] font-light leading-[20px] text-charcoal border rounded-[8px] outline-none transition-all focus-within:border-lime-green hover:border-lime-green border-light-gray/25;
  padding-right: 2rem;
  -webkit-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23333' d='M5 6L0 0h10L5 6z'/%3E%3C/svg%3E");
  background-position: right 16px center;
  background-repeat: no-repeat;
}

.select2-selection__arrow {
  @apply hidden;
}
</style>

